// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class UsersWithSiteAccountRequestModel {
    'portalId': string;
    'connectionName': string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof UsersWithSiteAccountRequestModel>> = [
        {
            "name":     "portalId",
            "baseName": "portalId",
            "type":     "string"
        },
        {
            "name":     "connectionName",
            "baseName": "connectionName",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return UsersWithSiteAccountRequestModel.attributeTypeMap;
    }
}
